/**
 * Genera buffers y fibras TIA-598 para un cable (misma lógica que CableFormModal).
 */

const COLORES_TIA598 = [
  'azul',
  'naranja',
  'verde',
  'marron',
  'gris',
  'blanco',
  'rojo',
  'negro',
  'amarillo',
  'violeta',
  'rosa',
  'turquesa',
] as const

function extremoLibre() {
  return { estado: 'libre' as const, conectadoA: null as string | null, splitterConectado: null }
}

function fibraLibre(numero: number, color: string, fibraId: string) {
  return {
    numero,
    color,
    fibraId,
    extremos: { origen: extremoLibre(), destino: extremoLibre() },
    // Deprecados, agregado de los dos extremos (ambos libres al crear la fibra).
    estado: 'libre' as const,
    conectadaA: null as string | null,
    splitterConectado: null as {
      splitterId: string
      tipoPuerto: 'entrada' | 'salida'
      numeroPuerto?: number
    } | null,
  }
}

export function generarEstructuraFibras(cableId: string, numFibras: number, tieneBuffers: boolean) {
  if (!tieneBuffers || numFibras <= 12) {
    const fibras = Array.from({ length: numFibras }, (_, i) =>
      fibraLibre(i + 1, COLORES_TIA598[i % 12], `${cableId}|SB|${COLORES_TIA598[i % 12]}`)
    )
    return { buffers: null, fibras }
  }

  const numBuffers = Math.ceil(numFibras / 12)
  let fibrasTotales = numFibras

  const buffers = Array.from({ length: numBuffers }, (_, bi) => {
    const fibrasEnEsteBuffer = Math.min(12, fibrasTotales)
    fibrasTotales -= fibrasEnEsteBuffer

    return {
      numero: bi + 1,
      color: COLORES_TIA598[bi % 12],
      fibras: Array.from({ length: fibrasEnEsteBuffer }, (_, fi) =>
        fibraLibre(fi + 1, COLORES_TIA598[fi], `${cableId}|${COLORES_TIA598[bi % 12]}|${COLORES_TIA598[fi]}`)
      ),
    }
  })

  return { buffers, fibras: null }
}
